import DataHelpers from './DataHelpers'
import FirebaseHelpers from './FirebaseHelpers'
import FireData from '../data/FireData'
import Store from '../store/Store'

export default class UserHelpers {
    static officesList() {   
        let offices = []
        let userKey = Store.getters.uid
        if(userKey) {
            const ref = DataHelpers.getRootRef().child('users').child(userKey).child('offices')
            console.log('UserHelpers > officesList > Ref', ref.toString())
            ref.on('value', snap => {
                offices = FirebaseHelpers.snapshotToArray(snap)
            })
        }
        return offices
    }
}


// WEBPACK FOOTER //
// ./src/helpers/UserHelpers.js